import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const IndexPage = lazy(() => import('modules/time_planning/pages/profile/IndexPage'))
const RootPage = lazy(() => import('modules/time_planning/pages/profile/RootPage'))

const profileRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.profile.planningVersions.path,
      element: <RootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('time_planning.title'),
        }),
      },
      children: [
        {
          index: true,
          element: <IndexPage />,
        },
        {
          path: navigation.profile.planningVersions.planningVersionId.path,
          element: <IndexPage />,
        },
      ],
    },
  ]
}

export default profileRoutes
